import React, { FC } from 'react'
import { Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@utils/routes'
import { useNavigate } from 'react-router-dom'
import ListItem from '@components/ListItem'

export * from './Components'

interface ListI {
  emoji: string
  primaryText: string
  secondaryText: string
  route: string
  navState?: any
}

const Settings: FC = () => {
  const { t } = useTranslation()

  const list: ListI[] = [
    {
      emoji: '🔑',
      primaryText: t('settings.seedPhrase.primaryText'),
      secondaryText: t('settings.seedPhrase.secondaryText'),
      route: ROUTES.KEY_REVEAL_ACCEPTANCE,
    },
    {
      emoji: '📱',
      primaryText: t('settings.dapps.primaryText'),
      secondaryText: t('settings.dapps.secondaryText'),
      route: ROUTES.CONNECTED_APPS,
    },
    {
      emoji: '💵',
      primaryText: t('settings.locale.primaryText'),
      secondaryText: t('settings.locale.secondaryText'),
      route: ROUTES.LOCALE_SETTINGS,
    },
    {
      emoji: '🔐',
      primaryText: t('settings.pem.primaryText'),
      secondaryText: t('settings.pem.secondaryText'),
      route: ROUTES.KEY_REVEAL_ACCEPTANCE,
      navState: { isPem: true },
    },
    {
      emoji: '🧪',
      primaryText: t('settings.testnet.primaryText'),
      secondaryText: t('settings.testnet.secondaryText'),
      route: ROUTES.DEVELOPER_SETTINGS,
    },
  ]

  return (
    <Stack spacing={1} px={1}>
      {list.map((item, index) => (
        <ListItem key={index} {...item} />
      ))}
      <Typography variant="caption" textAlign="center">
        v{import.meta.env.VITE_APP_VERSION}
      </Typography>
    </Stack>
  )
}

export default Settings
